/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M13 16H11C9.34315 16 8 14.6569 8 13C8 11.3431 9.34315 10 11 10H16L14 8"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<circle
				cx="12"
				cy="12"
				r="10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<circle opacity="0.12" cx="12" cy="12" r="10" fill="currentColor" />
			<path
				d="M13 16H11C9.34315 16 8 14.6569 8 13C8 11.3431 9.34315 10 11 10H16L14 8M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM14.5303 7.46967C14.2374 7.17678 13.7626 7.17678 13.4697 7.46967C13.1768 7.76256 13.1768 8.23744 13.4697 8.53033L14.1893 9.25H11C8.92893 9.25 7.25 10.9289 7.25 13C7.25 15.0711 8.92893 16.75 11 16.75H13C13.4142 16.75 13.75 16.4142 13.75 16C13.75 15.5858 13.4142 15.25 13 15.25H11C9.75736 15.25 8.75 14.2426 8.75 13C8.75 11.7574 9.75736 10.75 11 10.75H16C16.3033 10.75 16.5768 10.5673 16.6929 10.287C16.809 10.0068 16.7448 9.68417 16.5303 9.46967L14.5303 7.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M8 2.83209C9.22493 2.2969 10.5778 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 9.74835 2.74418 7.67051 4 5.99902M13 16H11C9.34315 16 8 14.6569 8 13C8 11.3431 9.34315 10 11 10H16L14 8"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M13 16H11C9.34315 16 8 14.6569 8 13C8 11.3431 9.34315 10 11 10H16L14 8M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.4697 7.46967C13.7626 7.17678 14.2374 7.17678 14.5303 7.46967L16.5303 9.46967C16.7448 9.68417 16.809 10.0068 16.6929 10.287C16.5768 10.5673 16.3033 10.75 16 10.75H11C9.75736 10.75 8.75 11.7574 8.75 13C8.75 14.2426 9.75736 15.25 11 15.25H13C13.4142 15.25 13.75 15.5858 13.75 16C13.75 16.4142 13.4142 16.75 13 16.75H11C8.92893 16.75 7.25 15.0711 7.25 13C7.25 10.9289 8.92893 9.25 11 9.25H14.1893L13.4697 8.53033C13.1768 8.23744 13.1768 7.76256 13.4697 7.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
